import { createFileRoute } from "@tanstack/react-router";
import { PageHead, Panel } from "@/components/dashboard-shell";

export const Route = createFileRoute("/admin/settings")({ component: AdminSettings });

function AdminSettings() {
  return (
    <>
      <PageHead title="Platform settings" subtitle="Branding, payments, receipts and approvals." />
      <div className="grid gap-4 md:grid-cols-2">
        <Panel title="Branding">
          <Field label="Foundation name" defaultValue="Manavta" />
          <Field label="Public domain" defaultValue="manavta.org" />
          <Field label="Tagline" defaultValue="Seva. Transparency. Impact." />
          <Field label="Primary colour" defaultValue="#2A2560 (Indigo)" />
          <Field label="Accent colour" defaultValue="#E89A1F (Saffron)" />
        </Panel>
        <Panel title="Payment gateway">
          <Field label="Primary gateway" defaultValue="Razorpay (Live)" />
          <Field label="Backup gateway" defaultValue="Cashfree (Standby)" />
          <Field label="Key ID" defaultValue="rzp_live_xxxxxx" />
          <Field label="Receipt prefix" defaultValue="DAF-" />
          <Field label="80G registration" defaultValue="AAATD1234F/12A · valid till 2029" />
        </Panel>
        <Panel title="Approvals">
          <Toggle label="Auto-approve verified institutions" />
          <Toggle label="Require admin review on every cause" defaultChecked />
          <Toggle label="Require expense proof for impact updates" defaultChecked />
          <Toggle label="Auto-flag causes with < 10% progress in 30 days" defaultChecked />
        </Panel>
        <Panel title="Communication">
          <Toggle label="Email donation receipts" defaultChecked />
          <Toggle label="WhatsApp donation receipts (beta)" />
          <Toggle label="SMS notifications" />
          <Toggle label="Monthly impact digest to all donors" defaultChecked />
        </Panel>
        <Panel title="Team & access">
          <Field label="Trustees with admin access" defaultValue="4 members" />
          <Field label="Regional coordinators" defaultValue="12 members" />
          <Field label="2FA required for admin logins" defaultValue="Enabled" />
        </Panel>
        <Panel title="Compliance & audits">
          <Field label="Statutory auditor" defaultValue="Kirtane & Pandit LLP" />
          <Field label="Last audit filed" defaultValue="FY 2024-25 · 30 Jun 2025" />
          <Field label="Data residency" defaultValue="Mumbai (ap-south-1)" />
        </Panel>
      </div>
    </>
  );
}

function Field({ label, defaultValue }: { label: string; defaultValue: string }) {
  return (
    <label className="block py-2">
      <span className="text-xs text-foreground/60">{label}</span>
      <input
        defaultValue={defaultValue}
        className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2 text-sm"
      />
    </label>
  );
}
function Toggle({ label, defaultChecked }: { label: string; defaultChecked?: boolean }) {
  return (
    <label className="flex items-center justify-between py-2 text-sm">
      <span>{label}</span>
      <input
        type="checkbox"
        defaultChecked={defaultChecked}
        className="h-4 w-4 accent-[var(--maroon)]"
      />
    </label>
  );
}
